import { Theme } from '@mui/material';
import { CustomField, CustomFieldDefinition, customFieldTypeConfig, CustomFieldType } from '../../../../../ts/CustomFieldType';

export interface CustomFieldAppearance {
    color: string;
    iconName?: string;
    fieldType?: CustomFieldType;
}

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

// The color is interpolated into an sx value, so reject anything that could inject extra declarations.
function sanitizeColor(value?: string): string | undefined {
    if (!value) return undefined;
    const normalized = value.startsWith('#') ? value : `#${value}`;
    return HEX_COLOR.test(normalized) ? normalized : undefined;
}

export function findCustomFieldDefinition(field: CustomField, definitions?: CustomFieldDefinition[]): CustomFieldDefinition | undefined {
    return definitions?.find(definition =>
        String(definition.customFieldID) === String(field.Id) ||
        definition.name.toLowerCase() === field.Name?.toLowerCase());
}

export function resolveCustomFieldAppearance(field: CustomField, theme: Theme, definitions?: CustomFieldDefinition[]): CustomFieldAppearance {
    const definition = findCustomFieldDefinition(field, definitions);
    const fieldType = field.FieldType ?? definition?.fieldType;
    const color = sanitizeColor(field.Color ?? definition?.color);
    return {
        color: color ?? theme.palette.spectre[customFieldTypeConfig(fieldType).accent],
        iconName: field.Icon ?? definition?.icon,
        fieldType,
    };
}
